import { jsxs as l, jsx as s } from "react/jsx-runtime";
import A, { useId as B } from "react";
import { e as D } from "../../error-eeUeT3Cz.js";
import { c as e } from "../../clsx-OuTLNxxd.js";
const M = A.forwardRef(
  ({
    label: g = "",
    placeholder: m = " ",
    id: i = "",
    value: t = "",
    disabled: o = !1,
    rows: w = 3,
    maxLength: n = 300,
    error: a = !1,
    wrapperClassName: y = "",
    inputClassName: N = "",
    labelClassName: d = "",
    labelWrapperClassName: C = "",
    containerClassesName: j = "",
    helperText: r = "",
    helperWrapperClassName: k = "",
    helperTextClassName: I = "",
    onChange: p
  }, W) => {
    const f = B(), z = e(
      // Layout
      "flex flex-col gap-1",
      // Additional Classes
      j
    ), R = e(
      // Layout
      "relative w-full overflow-hidden px-4 py-[11px] flex flex-col-reverse",
      // Background
      {
        "bg-input-surface-active": !a && !o,
        "bg-input-surface-error": a && !o,
        "bg-input-surface-disabled": o
      },
      // Focus
      "focus-within:border-input-stroke-active focus-within:shadow-focused-textarea hover:border-input-stroke-active",
      // Border
      "border border-transparent rounded",
      // Additional Classes
      y
    ), _ = e(
      // Layout
      "block w-full resize-none scrollbar bg-transparent pr-[2px]",
      // Text
      "text-body-b3-regular text-text-primary",
      // Appearance
      "appearance-none outline-none",
      // Peer
      "peer",
      // Additional Classes
      N
    ), F = e(
      // Text
      "flex gap-1 text-label-b5-regular text-input-text-disabled absolute left-0 top-0",
      // Animation
      "transition-all duration-300",
      // Additional Classes
      d
    ), x = e(
      // Text
      "text-label-b6-regular text-input-text-disabled capitalize",
      // Animation
      "transition-all duration-300",
      // Additional Classes
      d
    ), q = e(
      // Layout
      "flex justify-end select-none w-full relative",
      // Label & Span Default State
      "top-0 left-0",
      // Focus State
      "peer-focus:translate-x-0 peer-focus:translate-y-0 peer-focus:top-0 peer-focus:left-0 peer-focus:[&>label]:text-label-b5-regular peer-focus:[&>label]:text-input-text-label",
      // Placeholder Shown State
      "peer-placeholder-shown:translate-x-0 peer-placeholder-shown:-translate-y-0 peer-placeholder-shown:top-0 peer-placeholder-shown:left-0 peer-placeholder-shown:[&>label]:text-body-b3-regular peer-placeholder-shown:[&>label]:text-input-text-placeholder",
      // Animation
      "transition-all duration-300",
      // Additional Classes
      C
    ), u = e(
      {
        "flex gap-1 pl-4": typeof r == "string",
        "pl-4": typeof r != "string"
      },
      k
    ), v = e(
      "text-label-b5-regular",
      {
        "text-input-text-error": a,
        "text-input-text-disabled": !a
      },
      I
    );
    return /* @__PURE__ */ l("div", { className: z, children: [
      /* @__PURE__ */ l("div", { className: R, children: [
        /* @__PURE__ */ s(
          "textarea",
          {
            id: i || f,
            className: _,
            placeholder: m,
            value: t,
            onChange: (c) => {
              var b, h;
              n && ((h = (b = c == null ? void 0 : c.target) == null ? void 0 : b.value) == null ? void 0 : h.length) > n || p == null || p(c);
            },
            disabled: o,
            rows: w,
            ref: W
          }
        ),
        /* @__PURE__ */ l("div", { className: q, children: [
          /* @__PURE__ */ l(
            "label",
            {
              htmlFor: i || f,
              className: F,
              children: [
                /* @__PURE__ */ s("span", { className: "flex-1", children: g }),
                /* @__PURE__ */ l("span", { className: e(x, "invisible"), children: [
                  t == null ? void 0 : t.length,
                  " / ",
                  n
                ] })
              ]
            }
          ),
          /* @__PURE__ */ l("span", { className: x, children: [
            t == null ? void 0 : t.length,
            " / ",
            n
          ] })
        ] })
      ] }),
      r && (typeof r == "string" ? /* @__PURE__ */ l("div", { className: u, children: [
        a && /* @__PURE__ */ s(
          "img",
          {
            src: D,
            alt: "error"
          }
        ),
        /* @__PURE__ */ s("p", { className: v, children: r })
      ] }) : /* @__PURE__ */ s("div", { className: u, children: r }))
    ] });
  }
);
export {
  M as Textarea
};
